import React from 'react';

const stats = [
  { value: '50,000+', label: 'Active Students', icon: '🎓' },
  { value: '8,500+', label: 'Employers', icon: '🏢' },
  { value: '1,200+', label: 'Institutions', icon: '🏛️' },
  { value: '95%', label: 'Placement Rate', icon: '📈' },
];

const StatsSection = () => {
  return (
    <section className="py-16 bg-[var(--color-primary)]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats?.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-4xl mb-2">{stat?.icon}</div>
              <div className="text-3xl font-bold text-white mb-1" style={{ fontFamily: 'Crimson Text, serif' }}>
                {stat?.value}
              </div>
              <div className="text-blue-200 text-sm">{stat?.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
